import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { notificationAPI } from '../notificationAPI';

const TemplateSettingsPanel = () => {
  const { selectedLevel, levels } = useSelector(state => state.notification);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState({
    templates: false
  });
  const [viewModal, setViewModal] = useState({ isOpen: false, template: null });
  const [macroModal, setMacroModal] = useState({ isOpen: false });
  const [exampleModal, setExampleModal] = useState({ isOpen: false });
  const [expandedSections, setExpandedSections] = useState({});

  const exampleTemplates = [
    {
      id: 1,
      title: "과제 배정 시 알림",
      content: `📌 #{학생명}학생의 과제가 부여되었습니다.

👩‍🏫 클래스 : #{반이름}
📑 시험지 유형 : #{시험지유형}
📝 과제명 : #{과제명}
⏰ 마감일 : #{마감일}
🔗 학습 링크 : #{과제링크}

⚠️ 마감일이 지나면 과제가 자동 삭제 될 수 있으니 학습을 마감일 전에 마쳐주세요!

📤 과제 제출 완료 후 학부모님께 첨삭 해설지 링크를 보내드립니다.`
    },
    {
      id: 2,
      title: "마감일 3일 전 알림",
      content: `⏳ #{학생명}학생의 과제 마감일이 3일 남았습니다.
📊 현재 진도율은 #{진도율}% 입니다.

⚠️ 마감일이 지나면 과제가 자동 삭제 될 수 있으니 학습을 마감일 전에 마쳐주세요!

👩‍🏫 클래스 : #{반이름}
📑 시험지 유형 : #{시험지유형}
📝 과제명 : #{과제명}
⏰ 마감일 : #{마감일}
🔗 학습 링크 : #{과제링크}`
    },
    {
      id: 3,
      title: "과제 완료 시 알림",
      content: `✅ #{학생명}학생의 과제가 #{제출일} 채점완료 되었습니다.

👩‍🏫 클래스 : #{반이름}
📑 시험지 유형 : #{시험지유형}
📝 과제명 : #{과제명}
🎯 점수 : #{점수}
📄 첨삭결과 : #{과제리포트주소}

👉 위의 첨삭결과 링크를 클릭하시면, #{학생명}학생이 제출한 정답과 오답을 확인하실 수 있습니다.`
    },
    {
      id: 4,
      title: "마감일 지난 과제 알림",
      content: `🚨 #{학생명}학생의 과제 마감일이 지났습니다.
📊 현재 진도율은 #{진도율}% 입니다.

⚠️ 학습 마감일이 지났으니 서둘러 학습을 완료해주세요!

👩‍🏫 클래스 : #{반이름}
📑 시험지 유형 : #{시험지유형}
📝 과제명 : #{과제명}
⏰ 마감일 : #{마감일}
🔗 학습 링크 : #{과제링크}`
    }
    // {
    //   id: 5,
    //   title: "링크 리셋 멘트",
    //   content: `🔄 #{학생명}학생의 학습 링크가 재생성 되었습니다.

// 🔒 보안을 위해 #{학원명}에서는 정기적으로 학습 링크를 재생성 하고 있으니 지금부터는 아래 링크로 학습해주세요!
// 🔗 학습 링크 : #{과제링크}`
    // },
    // {
    //   id: 6,
    //   title: "지면테스트 링크",
    //   content: `📊 #{학생명}학생의 테스트 결과를 안내드립니다.

// 👩‍🏫 클래스 : #{반이름}
// 📝 제목 : #{과제명}
// 📅 날짜 : #{마감일}
// 🎯 점수 : #{점수}
// 📈 진도율 : #{진도율}%

// 지난 테스트 결과 및 학습 내역은 아래 학습링크를 참고해주세요!
// 🔗 링크 : #{과제링크}`
    // },
    // {
    //   id: 7,
    //   title: "지면 숙제 링크",
    //   content: `📘 #{학생명}학생의 숙제결과를 안내드립니다.

// 👩‍🏫 클래스 : #{반이름}
// 📝 제목 : #{과제명}
// 📅 날짜 : #{제출일}
// 🎯 점수 : #{점수}

// 지난 테스트 결과 및 학습 내역은 아래 학습링크를 참고해주세요!
// 🔗 링크 : #{과제링크}`
    // }
  ];

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('템플릿이 클립보드에 복사되었습니다!');
    } catch (error) {
      console.error('복사 실패:', error);
      alert('복사에 실패했습니다. 브라우저가 클립보드 접근을 지원하지 않습니다.');
    }
  };

  const createTemplateInSendon = async (template) => {
    try {
      const response = await notificationAPI.createFromExample({
        template_name: template.title,
        template_content: template.content,
        trigger_type: getTriggerTypeFromTitle(template.title)
      });
      
      console.log('=== 템플릿 생성 응답 디버깅 ===');
      console.log('전체 응답:', response);
      console.log('response.success:', response.success);
      console.log('response.message:', response.message);
      console.log('response.data:', response.data);
      
      // 실제 데이터는 response.data에 있을 수 있음
      const actualData = response.data || response;
      console.log('actualData:', actualData);
      
      if (actualData.success || actualData.message) {
        console.log(`센드온에 템플릿이 생성되었습니다! ${actualData.message || '생성 완료'}`);
        // 템플릿 목록 새로고침
        loadTemplatesFromSendon();
      } else {
        console.warn('예상하지 못한 응답 구조:', actualData);
        console.error('템플릿 생성에 실패했습니다.');
      }
    } catch (error) {
      console.error('템플릿 생성 실패:', error);
      console.error('에러 응답:', error.response);
      const errorMsg = error.response?.data?.error || error.message || '알 수 없는 오류가 발생했습니다.';
      console.error(`템플릿 생성 실패: ${errorMsg}`);
    }
  };

  const getTriggerTypeFromTitle = (title) => {
    if (title.includes('과제 부여')) return 'assignment_created';
    if (title.includes('D-day') || title.includes('마감일')) return 'dday_3_notification';
    if (title.includes('완료') || title.includes('점수')) return 'completion_notification';  
    if (title.includes('미완료') || title.includes('지난')) return 'reminder_notification';
    return 'assignment_created';
  };

  const loadTemplatesFromSendon = async () => {
    setLoading(prev => ({ ...prev, templates: true }));
    try {
      console.log('=== 센드온과 동기화 시작 ===');
      
      // 센드온과 동기화 - 업데이트된 sync_from_sendon API 사용
      console.log('1. 센드온 동기화 API 호출 중...');
      const syncResponse = await notificationAPI.syncTemplatesFromSendon();
      console.log('센드온 동기화 응답:', syncResponse);
      
      // 동기화 후 로컬에서 템플릿 목록 가져오기
      console.log('2. 로컬 템플릿 목록 조회 중...');
      const templatesResponse = await notificationAPI.getAlimtalkTemplates();
      console.log('템플릿 목록 응답:', templatesResponse);
      
      const data = templatesResponse.data || templatesResponse;
      console.log('처리된 데이터:', data);
      console.log('데이터 타입:', typeof data, '배열여부:', Array.isArray(data));
      
      setTemplates(Array.isArray(data) ? data : []);
      
      // 동기화 결과 표시
      if (syncResponse && syncResponse.message) {
        console.log(`동기화 성공: ${syncResponse.message}`);
        // 성공 메시지를 사용자에게 표시하고 싶다면 여기에 추가
      }
      
      console.log(`총 ${Array.isArray(data) ? data.length : 0}개 템플릿을 로드했습니다.`);
      
    } catch (error) {
      console.error('센드온 동기화 실패:', error);
      const errorMsg = error.response?.data?.error || error.message || '동기화 중 오류가 발생했습니다.';
      
      // 동기화 실패시에도 로컬 템플릿 로드 시도
      try {
        console.log('3. 동기화 실패, 로컬 템플릿만 로드 시도...');
        const response = await notificationAPI.getAlimtalkTemplates();
        console.log('로컬 템플릿 응답:', response);
        const data = response.data || response;
        setTemplates(Array.isArray(data) ? data : []);
        
        // 동기화 실패했지만 로컬 데이터는 로드 성공
        console.log(`동기화 실패 (${errorMsg}), 하지만 로컬 템플릿 ${Array.isArray(data) ? data.length : 0}개 로드됨`);
        
      } catch (fallbackError) {
        console.error('로컬 템플릿 로드도 실패:', fallbackError);
        setTemplates([]);
        
        // 콘솔에만 로그 출력
        console.error(`템플릿 동기화 실패: ${errorMsg}`);
      }
    } finally {
      setLoading(prev => ({ ...prev, templates: false }));
    }
  };

  useEffect(() => {
    loadTemplatesFromSendon();
  }, [selectedLevel]);



  const getCurrentLevel = () => {
    if (!selectedLevel) return null;
    return levels.find(level => level.id === parseInt(selectedLevel));
  };

  const getTemplatesForCurrentLevel = () => {
    const currentLevel = getCurrentLevel();
    
    // 디버깅을 위해 일시적으로 모든 템플릿 표시
    console.log('=== 템플릿 필터링 디버그 ===');
    console.log('현재 레벨:', currentLevel);
    console.log('전체 템플릿:', templates);
    console.log('템플릿 이름들:', templates.map(t => t.template_name));
    
    // 임시로 모든 템플릿을 표시하여 문제 확인
    return templates;
    
    // 원래 필터링 로직 (주석 처리)
    /*
    if (!currentLevel) {
      // 전체 설정일 때는 GLOBAL 템플릿만 표시
      return templates.filter(template => 
        template.template_name.startsWith('GLOBAL-')
      );
    }
    
    // 특정 반 선택 시 해당 반의 템플릿만 표시
    const levelCode = currentLevel.name.replace(/[^a-zA-Z0-9가-힣]/g, '');
    return templates.filter(template => 
      template.template_name.startsWith(`${levelCode}-`)
    );
    */
  };




  // 템플릿 내용 보기
  const handleViewTemplate = (template) => {
    setViewModal({ isOpen: true, template });
  };



  const getStatusBadge = (status) => {
    const statusConfig = {
      // SendOn API 상태들을 한국어로 매핑
      'DRAFT': { text: '작성중', className: 'status-draft' },
      'NEED_REVIEW': { text: '검수요청 필요', className: 'status-draft' }, // DRAFT와 동일하게 처리
      'PENDING': { text: '검수대기', className: 'status-pending' },
      'IN_REVIEW': { text: '검수중', className: 'status-pending' },
      'APPROVED': { text: '승인완료', className: 'status-approved' },
      'REJECTED': { text: '승인거절', className: 'status-rejected' },
      'COMPLETED': { text: '승인완료', className: 'status-approved' },
      'CANCELED': { text: '취소됨', className: 'status-rejected' },
      // 기존 상태들 (하위 호환)
      'draft': { text: '작성중', className: 'status-draft' },
      'pending': { text: '검수요청 필요', className: 'status-pending' },
      'approved': { text: '승인완료', className: 'status-approved' },
      'rejected': { text: '승인거절', className: 'status-rejected' }
    };
    
    const config = statusConfig[status] || { text: status, className: 'status-unknown' };
    return <span className={`status-badge ${config.className}`}>{config.text}</span>;
  };

  const currentLevel = getCurrentLevel();
  const currentTemplates = getTemplatesForCurrentLevel();

  return (
    <div className="template-settings-panel">
      <div className="panel-header">
        <div className="header-content">
          <h3>📄 템플릿 설정</h3>
          <p>{currentLevel ? `${currentLevel.name} 반의 알림톡 템플릿을 관리합니다.` : '전체 반용 공통 템플릿을 관리합니다.'}</p>
        </div>
        <div className="header-actions">
          <button
            className="refresh-button"
            onClick={loadTemplatesFromSendon}
            disabled={loading.templates}
            title="센드온과 동기화"
          >
            {loading.templates ? '센드온과 동기화 중...' : '센드온과 동기화'}
          </button>
          <button
            className="macro-guide-button"
            onClick={() => setMacroModal({ isOpen: true })}
            title="사용 가능한 매크로 보기"
          >
            매크로 안내
          </button>
          <button
            className="example-template-button"
            onClick={() => setExampleModal({ isOpen: true })}
            title="예시 템플릿 보기 및 센드온에 간편 생성"
          >
            예시 템플릿 및 간편 생성
          </button>
        </div>
      </div>

      <div className="templates-content">
        {loading.templates ? (
          <div className="loading-state">템플릿 목록을 불러오는 중...</div>
        ) : currentTemplates.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📄</div>
            <h4>생성된 템플릿이 없습니다.</h4>
            <p>센드온에서 템플릿을 생성해주세요.</p>
            <button 
              className="sendon-link-button"
              onClick={() => window.open('https://sendon.io', '_blank')}
            >
              센드온 열기
            </button>
          </div>
        ) : (
          <div className="templates-grid">
            {currentTemplates.map((template) => (
              <div key={template.id} className="template-card">
                <div className="template-header">
                  <div className="template-info">
                    <h5 className="template-name">{template.template_name}</h5>
                  </div>
                  {getStatusBadge(template.status)}
                </div>
                
                <div className="template-details">
                  <div className="detail-item">
                    <span className="label">등록일:</span>
                    <span className="value">{new Date(template.created_at).toLocaleDateString()}</span>
                  </div>
                </div>

                <div className="template-content-preview">
                  <p>{template.template_content.substring(0, 100)}...</p>
                </div>

                <div className="template-actions">
                  <button
                    className="view-button"
                    onClick={() => handleViewTemplate(template)}
                  >
                    내용 보기
                  </button>
                </div>

                {template.inspection_comment && (
                  <div className="inspection-comment">
                    <strong>검수 의견:</strong> {template.inspection_comment}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 매크로 안내 모달 */}
      {macroModal.isOpen && (
        <div className="modal-overlay" onClick={() => setMacroModal({ isOpen: false })}>
          <div className="modal-content macro-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📝 사용 가능한 매크로</h3>
              <button 
                className="close-button"
                onClick={() => setMacroModal({ isOpen: false })}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              <div className="macro-list">
                <div className="macro-item">
                  <code>#{'{'}학생명{'}'}</code>
                  <span>학생 이름</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}학원명{'}'}</code>
                  <span>학원 이름</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}반이름{'}'}</code>
                  <span>반 이름</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}과제명{'}'}</code>
                  <span>과제 제목</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}시험지유형{'}'}</code>
                  <span>시험지 유형</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}마감일{'}'}</code>
                  <span>과제 마감일</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}제출일{'}'}</code>
                  <span>과제 제출일</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}과제링크{'}'}</code>
                  <span>과제 수행 링크</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}점수{'}'}</code>
                  <span>과제 점수</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}진도율{'}'}</code>
                  <span>과제 진도율</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}과제리포트주소{'}'}</code>
                  <span>상세 리포트 링크</span>
                </div>
                {/* 통계 매크로들은 현재 미구현으로 주석 처리
                <div className="macro-item">
                  <code>#{'{'}평균점수{'}'}</code>
                  <span>평균 점수</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}등수{'}'}</code>
                  <span>등수</span>
                </div>
                <div className="macro-item">
                  <code>#{'{'}응시인원{'}'}</code>
                  <span>응시 인원</span>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 예시 템플릿 모달 */}
      {exampleModal.isOpen && (
        <div className="modal-overlay" onClick={() => setExampleModal({ isOpen: false })}>
          <div className="modal-content example-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📝 예시 템플릿</h3>
              <button 
                className="close-button"
                onClick={() => setExampleModal({ isOpen: false })}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              <p>아래 템플릿들을 참고하여 센드온에서 템플릿을 생성해주세요.</p>
              
              <div className="example-templates-list">
                {exampleTemplates.map(template => (
                  <div key={template.id} className="example-template-item">
                    <div 
                      className="example-template-header"
                      onClick={() => toggleSection(template.id)}
                    >
                      <h4>{template.id}. {template.title}</h4>
                      <span className={`expand-icon ${expandedSections[template.id] ? 'expanded' : ''}`}>
                        ▼
                      </span>
                    </div>
                    
                    {expandedSections[template.id] && (
                      <div className="example-template-content">
                        <div className="template-preview">
                          <pre>{template.content}</pre>
                        </div>
                        <div className="template-actions">
                          <button
                            className="copy-button"
                            onClick={() => copyToClipboard(template.content)}
                          >
                            📋 복사하기
                          </button>
                          <button
                            className="create-sendon-button"
                            onClick={() => createTemplateInSendon(template)}
                          >
                            🚀 센드온에 템플릿 간편 생성하기
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 내용 보기 모달 */}
      {viewModal.isOpen && (
        <div className="modal-overlay" onClick={() => setViewModal({ isOpen: false, template: null })}>
          <div className="modal-content view-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📄 템플릿 내용 보기</h3>
              <button 
                className="close-button"
                onClick={() => setViewModal({ isOpen: false, template: null })}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              <div className="template-info">
                <h4>{viewModal.template?.template_name || viewModal.template?.templateName || '제목 없음'}</h4>
              </div>
              
              <div className="template-content-full">
                <pre>{viewModal.template?.template_content || viewModal.template?.templateContent || '내용이 없습니다.'}</pre>
              </div>
            </div>
            
            <div className="modal-footer">
              <button
                className="close-button-modal"
                onClick={() => setViewModal({ isOpen: false, template: null })}
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      )}


      <style jsx>{`
        .template-settings-panel {
          padding: 20px;
        }

        .panel-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 1px solid #e0e0e0;
        }

        .header-content h3 {
          margin: 0 0 8px 0;
          font-size: 20px;
          color: #333;
        }

        .header-content p {
          margin: 0;
          color: #666;
          font-size: 14px;
        }

        .header-actions {
          display: flex;
          gap: 12px;
        }

        .refresh-button, .create-button, .macro-guide-button, .sendon-link-button, .example-template-button {
          padding: 10px 20px;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }

        .refresh-button {
          background: #17a2b8;
          color: white;
        }

        .refresh-button:hover:not(:disabled) {
          background: #138496;
        }

        .create-button {
          background: #28a745;
          color: white;
        }

        .create-button:hover:not(:disabled) {
          background: #218838;
        }

        .macro-guide-button {
          background: #6f42c1;
          color: white;
        }

        .macro-guide-button:hover:not(:disabled) {
          background: #5a2d91;
        }

        .example-template-button {
          background: #fd7e14;
          color: white;
        }

        .example-template-button:hover:not(:disabled) {
          background: #e8650e;
        }

        .sendon-link-button {
          background: #007bff;
          color: white;
          margin-top: 16px;
        }

        .sendon-link-button:hover:not(:disabled) {
          background: #0056b3;
        }

        .refresh-button:disabled, .create-button:disabled, .macro-guide-button:disabled, .sendon-link-button:disabled, .example-template-button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

        .templates-content {
          min-height: 200px;
        }

        .loading-state, .empty-state {
          text-align: center;
          padding: 40px;
          color: #666;
        }

        .empty-icon {
          font-size: 48px;
          margin-bottom: 16px;
        }

        .empty-state h4 {
          margin-bottom: -16px;
          font-size: 18px;
          color: #333;
        }

        .templates-grid {
          display: grid;
          gap: 20px;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        }

        .template-card {
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 20px;
          background: #fafafa;
          transition: shadow 0.2s;
        }

        .template-card:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .template-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: -8px;
        }

        .template-name {
          margin: 0 0 4px 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .template-code {
          font-size: 12px;
          color: #666;
          font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        }

        .sync-status {
          margin-top: 4px;
        }


        .status-badge {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;
        }

        .status-draft {
          background: #e2e3e5;
          color: #383d41;
          border: 1px solid #d6d8db;
        }

        .status-pending {
          background: #fff3cd;
          color: #856404;
          border: 1px solid #ffeaa7;
        }

        .status-approved {
          background: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb;
        }

        .status-rejected {
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
        }

        .template-details {
          margin-bottom: 12px;
        }

        .detail-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
          font-size: 14px;
        }

        .detail-item .label {
          color: #666;
          font-weight: 500;
        }

        .detail-item .value {
          color: #333;
        }

        .template-content-preview {
          margin-bottom: 16px;
          padding: 12px;
          background: white;
          border: 1px solid #e9ecef;
          border-radius: 4px;
          font-size: 14px;
          color: #333;
          line-height: 1.4;
        }

        .template-actions {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .view-button, .edit-button, .approve-button, .cancel-button, .delete-button {
          padding: 6px 12px;
          border: none;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          margin-right: 4px;
        }

        .view-button {
          background: #6c757d;
          color: white;
        }

        .view-button:hover:not(:disabled) {
          background: #5a6268;
        }

        .edit-button {
          background: #007bff;
          color: white;
        }

        .edit-button:hover:not(:disabled) {
          background: #0056b3;
        }

        .approve-button {
          background: #28a745;
          color: white;
        }

        .approve-button:hover:not(:disabled) {
          background: #218838;
        }

        .cancel-button {
          background: #ffc107;
          color: #212529;
        }

        .cancel-button:hover:not(:disabled) {
          background: #e0a800;
        }

        .delete-button {
          background: #e74c3c;
          color: white;
        }

        .delete-button:hover:not(:disabled) {
          background: #c0392b;
        }

        .view-button:disabled, .edit-button:disabled, .approve-button:disabled, .cancel-button:disabled, .delete-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .inspection-comment {
          margin-top: 12px;
          padding: 8px;
          background: #fff3cd;
          border: 1px solid #ffeaa7;
          border-radius: 4px;
          font-size: 13px;
          color: #856404;
        }

        /* 모달 스타일 */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 700px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
        }

        .view-modal {
          max-width: 800px;
        }

        .edit-modal {
          max-width: 700px;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e9ecef;
          background: #f8f9fa;
          border-radius: 12px 12px 0 0;
        }

        .modal-header h3 {
          margin: 0;
          font-size: 18px;
          color: #333;
          font-weight: 600;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
          padding: 4px;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          transition: all 0.2s;
        }

        .close-button:hover {
          background: rgba(0, 0, 0, 0.1);
          color: #333;
        }

        .modal-body {
          padding: 24px;
        }

        .template-info {
          margin-bottom: 20px;
        }

        .template-info h4 {
          margin: 0 0 12px 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .template-meta {
          display: flex;
          gap: 20px;
          margin-bottom: 16px;
        }

        .meta-item {
          font-size: 14px;
          color: #666;
        }

        .meta-item strong {
          color: #333;
        }

        .template-content-full {
          background: #f8f9fa;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 16px;
          font-family: 'Courier New', monospace;
        }

        .template-content-full pre {
          margin: 0;
          white-space: pre-wrap;
          word-wrap: break-word;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
        }

        .edit-note {
          background: #fff3cd;
          border: 1px solid #ffeaa7;
          border-radius: 6px;
          padding: 12px;
          margin-bottom: 16px;
          font-size: 14px;
          color: #856404;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #333;
          font-size: 14px;
        }

        .form-group textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 6px;
          font-family: 'Courier New', monospace;
          font-size: 14px;
          line-height: 1.5;
          resize: vertical;
          box-sizing: border-box;
          transition: border-color 0.2s;
        }

        .form-group textarea:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
        }

        .form-group small {
          display: block;
          margin-top: 6px;
          font-size: 12px;
          color: #666;
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          padding: 20px 24px;
          border-top: 1px solid #e9ecef;
          background: #f8f9fa;
          border-radius: 0 0 12px 12px;
        }

        .close-button-modal, .cancel-button-modal, .save-button-modal {
          padding: 10px 20px;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }

        .close-button-modal, .cancel-button-modal {
          background: #6c757d;
          color: white;
        }

        .close-button-modal:hover, .cancel-button-modal:hover {
          background: #5a6268;
        }

        .save-button-modal {
          background: #007bff;
          color: white;
        }

        .save-button-modal:hover:not(:disabled) {
          background: #0056b3;
        }

        .save-button-modal:disabled {
          background: #ccc;
          cursor: not-allowed;
        }


        @media (max-width: 768px) {
          .template-settings-panel {
            padding: 16px;
          }
          
          .panel-header {
            flex-direction: column;
            gap: 16px;
          }
          
          .header-actions {
            width: 100%;
            justify-content: stretch;
          }
          
          .header-actions button {
            flex: 1;
          }

          .templates-grid {
            grid-template-columns: 1fr;
          }
        }

        .macro-modal .macro-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .macro-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 16px;
          background: #f8f9fa;
          border-radius: 6px;
          border: 1px solid #e9ecef;
        }

        .macro-item code {
          background: #6f42c1;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-family: 'Courier New', monospace;
          font-weight: bold;
        }

        .macro-item span {
          color: #333;
          font-size: 14px;
          font-weight: 600;
        }

        .example-modal {
          max-width: 900px;
        }

        .example-templates-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
          margin-top: 16px;
        }

        .example-template-item {
          border: 1px solid #e9ecef;
          border-radius: 8px;
          overflow: hidden;
        }

        .example-template-header {
          padding: 16px 20px;
          background: #f8f9fa;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e9ecef;
          transition: background-color 0.2s;
        }

        .example-template-header:hover {
          background: #e9ecef;
        }

        .example-template-header h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }

        .expand-icon {
          font-size: 12px;
          transition: transform 0.2s;
          color: #666;
        }

        .expand-icon.expanded {
          transform: rotate(180deg);
        }

        .example-template-content {
          padding: 20px;
        }

        .template-preview {
          background: #f8f9fa;
          border: 1px solid #e9ecef;
          border-radius: 6px;
          padding: 16px;
          margin-bottom: 16px;
        }

        .template-preview pre {
          margin: 0;
          white-space: pre-wrap;
          word-wrap: break-word;
          font-family: 'Courier New', monospace;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
        }

        .template-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          flex-wrap: wrap;
        }

        .copy-button, .create-sendon-button {
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          transition: background-color 0.2s;
          font-weight: 500;
        }

        .copy-button {
          background: #28a745;
          color: white;
        }

        .copy-button:hover {
          background: #218838;
        }

        .create-sendon-button {
          background: #007bff;
          color: white;
        }

        .create-sendon-button:hover {
          background: #0056b3;
        }

        @media (max-width: 768px) {
          .example-modal {
            width: 95%;
          }

          .example-template-header {
            padding: 12px 16px;
          }

          .example-template-content {
            padding: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default TemplateSettingsPanel;
